import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import AddressInput from '../AddressInput';
import LabeledInput from '../LabeledInput';
import SameAsPatientOrCustom from '../SameAsPatientOrCustom';

import * as api from '../../api';
import {
  convertAddressToPlace,
  convertPlaceToAddress,
} from '../AddressInput/utils';
import { FormSetSelected } from '../../reducers/store';
import { getSelectedPracticePreference } from '../../utils/formSet';

interface Props extends StateProps {
  patientAddress: api.Address.Address | null;
  value: api.Address.Address | null;
  onChange: (address: api.Address.Address | null) => void;
  label?: string;
}

interface StateProps {
  previsitAddressValidCharacterSet: api.PracticePreference.PrevisitAddressValidCharacterSet;
}

const MailingAddressInput: React.FC<Props> = ({
  patientAddress,
  value,
  previsitAddressValidCharacterSet,
  onChange,
  label = 'Mailing Address',
}) => {
  const { t } = useTranslation();
  return (
    <LabeledInput label={t(label)} htmlFor="guarantor-address">
      <SameAsPatientOrCustom
        customInputRender={(isDisabled) => (
          <AddressInput
            id="guarantor-address"
            previsitAddressValidCharacterSet={previsitAddressValidCharacterSet}
            initialPlace={value ? convertAddressToPlace(value) : undefined}
            onSave={(place: api.Places.PlaceDetails) => {
              onChange(convertPlaceToAddress(place));
            }}
            disabled={isDisabled}
          />
        )}
        customElementName="address"
        value={value}
        onSameAsPatientClicked={() => onChange(patientAddress)}
        patientValue={patientAddress}
      />
    </LabeledInput>
  );
};

function mapStateToProps(store: FormSetSelected): StateProps {
  return {
    previsitAddressValidCharacterSet:
      getSelectedPracticePreference(store).previsitAddressValidCharacterSet,
  };
}
export default connect(mapStateToProps)(MailingAddressInput);
